<template>
  <div class="container">
      <router-view/>
    <a class="logo__container" href="https://investsurrey.ca" target="_blank">
      <img class="logo__image" src="./assets/CoS-Logo.svg" alt="">
    </a>
  </div>
</template>

<script>
  export default {
    name: 'app',
  };
</script>

<style lang="scss">
  @import 'main.scss';
  @import 'nav.scss';

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  html {
    box-sizing: border-box;
    font-size: 62.5%;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }



  body {
    background: #fff;
    color: $appBody;
    font-family: $defaultFont;
    font-weight: 200;
    letter-spacing: 2px;
    text-transform: uppercase;
    overflow: hidden;
  }
  h1, h2, h3, h4, h5, h6 {
    font-weight: 200;
  }
  .container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }

  .logo__container {
    display: block;
    width: 200px;
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 100;
  }

  .logo__image {
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    .logo__image {
      width: auto;
      height: 40px;
    }
    .logo__container {
      top: 1rem;
    }
  }
  .stats {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    /*display: none;*/
  }

  .basicLightbox {
    background: rgba(0,0,0,.4) !important;

    .modal--globe {


      background: rgba(#092531, 0.75);

      font-family: $defaultFont;
      border-radius: 10px !important;
      color: #fff;
      padding: 40px;
      width: 525px;

      h1, h2, p {
        margin: 0;
        font-weight: 200;
        margin-bottom: 2rem;
      }

      p:last-child {
        margin-bottom: 0;
      }

      h1 {
        color: $appPrimary;
        font-size: 3rem;
        letter-spacing: 4px;
        line-height: 3.5rem;
      }

      h2 {
        font-size: 2rem;
        letter-spacing: 4px;
        line-height: 2.5rem;
      }

      p {
        font-size: 1.4rem;
        text-transform: none;
      }
    }

    @media only screen and (max-width: 600px) {
      .modal--globe {
        width: 100%;
      }
       
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue